export default "__VITE_ASSET__d4f99266__"